import PersonToInstRelationTypeEntity from "../Entities/PersonToInstRelationTypeEntity";
import CachedBaseService from "./CachedBaseService";

export default class PersonToInstRelationTypeService extends CachedBaseService<PersonToInstRelationTypeEntity> {
    private SERVICE_NAME = "PersonToInstRelationTypeService";
    private ODATA_ROUTE = "PersonToInstRelationType";

    protected getServiceName(): string {
        return this.SERVICE_NAME;
    }

    protected getOdataRoute(): string {
        return this.ODATA_ROUTE;
    }

    protected mapDtoToEntity(dto: any): PersonToInstRelationTypeEntity {
        return PersonToInstRelationTypeEntity.fromOdata(dto, new PersonToInstRelationTypeEntity());
    }
}
